// extracted by mini-css-extract-plugin
export var container = "ShippingProgressBar_container__uGfvD";
export var progressBarBackground = "ShippingProgressBar_progressBarBackground__mZ3ch";
export var progressBarFill = "ShippingProgressBar_progressBarFill__mr4NE";